import type { ModalTypeProps } from '../types'

export const MODAL_SIZES = {
  sm: 's',
  lg: 'l',
}

const PREMIUM_BLACK_FRIDAY_CHECKOUT_URL =
  'https://www.serasa.com.br/premium/checkout/PREMIUM_ANUAL?cupom=BLACKFRIDAY2022'

const CTA_PROPS = {
  label: 'Assinar Premium 30% OFF',
  link: PREMIUM_BLACK_FRIDAY_CHECKOUT_URL,
  ariaLabel: 'Assinar o Premium com 30 porcento de desconto',
}

const COLOR_MODIFIER = 'light'

export enum LinkSecurityTypeParser {
  'safe' = 'safe',
  'unsafe' = 'unsafe',
  'pay-attention' = 'payAttention',
}

export const MODALS_CONTENT: ModalTypeProps = {
  safe: {
    title: 'Esse site é seguro',
    accessibleTitle:
      'Este site é seguro. Para que seus dados continuem à salvo, conte com os alertas do Premium',
    subtitle:
      'Oba, esse site parece ser seguro! Para que seus dados continuem à salvo, conte com os alertas do Premium.',
    colorModifier: COLOR_MODIFIER,
    cta: CTA_PROPS,
  },
  unsafe: {
    title: 'Esse site não é seguro',
    accessibleTitle:
      'Este site não é seguro, evite inserir seus dados. Assine o Premium e tenha os dados monitorados 24 horas por dia',
    subtitle:
      'Opa, esse site não parece muito seguro. Melhor se prevenir e evitar inserir seus dados. Conte com os alertas do Premium e fique com os dados monitorados 24h por dia.',
    colorModifier: COLOR_MODIFIER,
    cta: CTA_PROPS,
  },
  payAttention: {
    title: 'Não conseguimos identificar o site informado',
    accessibleTitle:
      'Não conseguimos encontrar o site informado. Melhor se prevenir e evitar inserir seus dados. Para que seus dados continuem à salvo, conte com os alertas do Premium',
    subtitle:
      'Ops, não conseguimos encontrar esse site. Melhor se prevenir e evitar inserir seus dados. Para que seus dados continuem à salvo, conte com os alertas do Premium.',
    colorModifier: COLOR_MODIFIER,
    cta: CTA_PROPS,
  },
  requestFailed: {
    title: 'Houve um problema ao atender a requisição',
    accessibleTitle:
      'Não conseguimos analisar este site. Melhor se previnir e evitar inserir seus dados. Para que seus dados continuem à salvo, conte com os alertas do Premium.',
    subtitle:
      'Ops! Não conseguimos analisar esse site. Melhor se previnir e evitar inserir seus dados. Para que seus dados continuem à salvo, conte com os alertas do Premium.',
    colorModifier: COLOR_MODIFIER,
    cta: CTA_PROPS,
  },
}
